module.exports = __webpack_public_path__ + "static/media/ZH.87d6c351.svg";